import { availableTermsForSkuSelector } from './OfferSelectors';
import { hasProductLevelOrHigherInProductInventorySelector } from './ProductInventorySelectors';
import { productForSkuIdSelector } from './ProductsSelectors';
export const shouldShowTermSelectorForMerchSelector = (state, {
  skuId
}) => {
  const availableTerms = availableTermsForSkuSelector(state, {
    skuId
  });
  const hasTwoTerms = availableTerms.length > 1;
  const {
    productLine,
    productLevel
  } = productForSkuIdSelector(state, {
    skuId
  }) || {};
  const ownsProductOrHigher = hasProductLevelOrHigherInProductInventorySelector(state, {
    productLine,
    productLevel
  });
  return hasTwoTerms && !ownsProductOrHigher;
};